
import React from "react";
import PageLayout from "@/components/PageLayout";
import { Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const Contact = () => {
  return (
    <PageLayout 
      title="Contact Us" 
      description="Have questions or feedback? We'd love to hear from you."
    >
      <div className="grid md:grid-cols-2 gap-10">
        {/* Contact Information */}
        <div className="space-y-8">
          <div>
            <h2 className="text-xl font-semibold text-redflags-dark mb-6">Get in Touch</h2>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="bg-redflags-red/10 p-2 rounded-full">
                  <Mail className="h-5 w-5 text-redflags-red" />
                </div>
                <div>
                  <h3 className="font-medium text-redflags-dark">Email</h3>
                  <p className="text-redflags-gray">support@redflags.com</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="bg-redflags-red/10 p-2 rounded-full">
                  <Phone className="h-5 w-5 text-redflags-red" />
                </div>
                <div>
                  <h3 className="font-medium text-redflags-dark">Phone</h3>
                  <p className="text-redflags-gray">+1 (555) 123-4567</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="bg-redflags-red/10 p-2 rounded-full">
                  <MapPin className="h-5 w-5 text-redflags-red" />
                </div>
                <div>
                  <h3 className="font-medium text-redflags-dark">Office</h3>
                  <p className="text-redflags-gray">
                    123 Transparency Way<br />
                    San Francisco, CA 94105<br />
                    United States
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="text-xl font-semibold text-redflags-dark mb-6">Hours</h2>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-redflags-gray">Monday – Friday:</span>
                <span className="text-redflags-dark">9:00 AM – 6:00 PM PST</span>
              </div>
              <div className="flex justify-between">
                <span className="text-redflags-gray">Saturday:</span>
                <span className="text-redflags-dark">10:00 AM – 4:00 PM PST</span>
              </div>
              <div className="flex justify-between">
                <span className="text-redflags-gray">Sunday:</span>
                <span className="text-redflags-dark">Closed</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Contact Form */}
        <div className="bg-slate-50 p-6 rounded-xl border border-slate-100">
          <h2 className="text-xl font-semibold text-redflags-dark mb-6">Send Us a Message</h2>
          <form className="space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="firstName">First Name</Label>
                <Input id="firstName" placeholder="First name" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="lastName">Last Name</Label>
                <Input id="lastName" placeholder="Last name" />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" placeholder="Your email address" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="subject">Subject</Label>
              <Input id="subject" placeholder="What is this regarding?" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="message">Message</Label>
              <Textarea 
                id="message" 
                placeholder="How can we help you?" 
                className="min-h-[120px]"
              />
            </div>
            <Button className="w-full bg-redflags-red hover:bg-redflags-red/90">
              Send Message
            </Button>
          </form>
        </div>
      </div>
    </PageLayout>
  );
};

export default Contact;
